import { Component, Input, OnInit, Inject, Optional } from '@angular/core';
import { BankAccountModel } from './bankaccount.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { BankAccountBicsModel } from './bankaccountbics.model';
import { UntypedFormControl } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { BankAccountService } from './bankaccount.service';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BankAccountComponent } from './bankaccount.component';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../shared/services/shared.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BankAccountDialogImportAccount } from './bankaccount-dialog-importAccount.component';

@Component({
    selector: 'convfact-bankaccount-form',
    templateUrl: './bankaccount-form.component.html',
    styleUrls: ['./bankaccount.component.css'],
    standalone: false
})
export class BankAccountFormComponent implements OnInit {
  bankAccount: BankAccountModel;

  @Output() onSave = new EventEmitter<any>();

  @Input() errors: object;

  uid: string = this.data.uid;
  userCompany: UserCompanyModel;
  bankAccountBics: BankAccountBicsModel[] = [];
  bicsCtrl: UntypedFormControl;
  filteredBics: Observable<BankAccountBicsModel[]>;
  ready = false;
  public isEdit = false;
  showApiKey = false;

  //AccountMovementes Import data
  flagImport: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //----------------------------------

  constructor(
    public dialogRef: MatDialogRef<BankAccountComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRefimport: MatDialogRef<AccountingMovementsImportComponent>,
    private bankAccountService: BankAccountService,
    private userCompanyService: UserCompanyService,
    private sharedService: SharedService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  closeDialog() {
    if (this.saved) {
      this.dialogRef.close('true');
    } else {
      this.dialogRef.close('false');
    }
  }

  ngOnInit() {
    this.bankAccount = new BankAccountModel();
    //Creo cuenta del banco desde sección de factuone

    //Uid con valor, cargamos los datos (el valor 0 es para distinguir del formulario de importación)
    //Si el Uid tiene longitud 36, queremos hacer peticion al back para cargar información
    if (this.uid != null) {
      const uid = this.uid.length;
      if (uid == 36) {
        this.isEdit = true;
        this.bankAccountService.loadData(this.uid).then(response => {
          this.bankAccount = response;
        });
      }
    }

    this.userCompanyService.loadData().then(userCompany => {
      this.userCompany = userCompany;
      this.bankAccountService.getBics().then(response => {
        this.bankAccountBics = response;
        this.bicsCtrl = new UntypedFormControl();
        this.filteredBics = this.bicsCtrl.valueChanges
          .pipe(
            map(bankAccountBics => bankAccountBics && typeof bankAccountBics === 'object' ? bankAccountBics.bank : bankAccountBics),
            map(name => this.filterBics(name))
          );

        //Creo cuenta del banco desde formulario de importación
        if (this.data.uid == "0") {
          this.flagImport = this.data.flagImport;
          this.movement = this.data.movement;
          this.type = this.data.type;
          this.bankAccount.manualMovement = this.movement;
          this.bankAccount.manualMovement.type = this.type;

          this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
            this.bankAccount.accountNumber = response;
            this.bankAccount.manualMovement.accountNumber = response;
          })

        }
        //------------------------------------------------------
        this.ready = true;

        //Uid con valor, cargamos los datos (el valor 0 es para distinguir del formulario de importación)
        //Si el Uid tiene longitud 36, queremos hacer peticion al back para cargar información
        /* if (this.uid != null) {
          let uid = this.uid.length;
          if (uid == 36) {
            this.bicsCtrl.disable();
          }
        } */
      });
    });
  }

  isBic(value: string) {
    return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(value.toUpperCase());
  }

  filterBics(val) {
    const self = this;
    for (const bic of this.bankAccountBics) {
      if (bic.bank === val) {
        self.bankAccount.swift = bic.bic;
      }
    }
    return val ? this.bankAccountBics.filter(s => s.bank.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.bankAccountBics;
  }

  public save(bankAccount): void {
    /*  if (this.validateIBAN(this.bankAccount.iban) === false) {
       this.displayInfo('El número IBAN no es válido');
       return;
     } */

    if (this.isBic(this.bankAccount.swift)) {
      if (this.data.uid == "0") { //Venimos de formulario de importación
        this.saveData(bankAccount);
        this.saved = true;
        this.closeDialog();
      } else { //Venimos de sección de factuone
        this.closeDialog();
        this.onSave.emit(bankAccount);
      }
    } else {
      alert("BIC/Swift incorrecto");
    }
  }

  public changeToggle(element, other) {
    this.bankAccount[other] = (this.bankAccount[element]);
  }

  public saveData(bankAccount): void {
    this.bankAccountService.addData(bankAccount)
      .then(bankAccountAdd => {
        // this.bankAccount = bankAccountAdd;
        this.closeDialog();
      },
        error => {
          //Si venimos de importar, y ya existe la cuenta bancaria, preguntamos si queremos actualizar
          //la cuenta bancaria ya existente
          if (error.error['message'].includes("ya se encuentra registrado") && this.data != null) {
            this.dialog.open(BankAccountDialogImportAccount, {
              width: '20%',
              //height: '40%',
              data: {
                dataImport: bankAccount,
              }
            }).afterClosed().subscribe(result => this.closeDialog())
          } else {
            this.displayInfo(error.error['message']);
          }
        })
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public validateIBAN(iban: string): boolean {
    // Remove white spaces and convert to uppercase
    iban = iban.replace(/\s/g, '').toUpperCase();

    // Check if IBAN has correct format
    if (!iban.match(/^[A-Z]{2}\d{2}[A-Z\d]{4}\d{7}([A-Z\d]?){0,16}$/)) {
      return false;
    }

    // Extract country code and check digit
    const country = iban.substring(0, 2);
    const checkDigit = parseInt(iban.substring(2, 4), 10);

    // Move first 4 characters to the end of IBAN and convert letters to numbers
    const ibanMoved = iban.substring(4) + iban.substring(0, 4).replace(/[A-Z]/g, (char) => {
      return (char.charCodeAt(0) - 55).toString();
    });

    // Verify if IBAN is valid
    let remainder = 0;
    for (let i = 0; i < ibanMoved.length; i++) {
      remainder = (remainder * 10 + parseInt(ibanMoved.charAt(i), 10)) % 97;
    }

    return remainder === 1;
  }

  public trackByIndex(i: number) { return i; }

}
